<template>
	<basic-container :block="true">
		<el-card header="更新数据">
			<div>
				<div>
					<el-button :loading="isLoading" style="width: 150px" type="primary" @click="onRefreshArea">
						更新省市区
					</el-button>
				</div>
				<div style="margin-top: 20px; display: flex">
					<el-button :loading="isLoading" style="width: 150px" type="primary" @click="onRefreshGong">
						更新工种
					</el-button>
					<el-select
						v-model="productId"
						:loading="isSelecting"
						placeholder="请选择产品"
						filterable
						style="margin-left: 30px; width: 200px">
						<el-option
							v-for="item in productOptions"
							:key="item.productId"
							:label="item.title"
							:value="item.productId"></el-option>
					</el-select>
				</div>

				<div style="margin-top: 20px; display: flex; align-items: center">
					<el-button :loading="isLoading" style="width: 150px" type="primary" @click="onGetNewCode">
						获取最新验证码
					</el-button>
					<div style="margin-left: 30px">
						<el-input v-model="phoneNum" placeholder="请输入手机号" style="width: 200px"></el-input>
					</div>

					<div v-if="newCode !== ''" style="margin-left: 40px">
						最新验证码：
						<span class="red-bold">{{ newCode }}</span>
					</div>
				</div>
			</div>
		</el-card>
		<el-card v-if="getPermissions.isShowSecret" header="临时密码" style="margin-top: 20px">
			<avue-form ref="refSecret" v-model="secretFromData" :option="secretOptions" @submit="onGetNewSecret">
				<template slot="secretText">
					<span class="red-bold">{{ secretFromData.secretText }}</span>
				</template>
			</avue-form>
		</el-card>
	</basic-container>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件等等）
// import { mapGetters } from 'vuex'

import {getNewCode, getNewSecret, refreshArea, refreshCategory} from '@/api/admin/dict'
import {fetchList} from '@/api/product/productManage'
import {mapGetters} from 'vuex'

export default {
	name: 'refresh',
	mixins: [],
	components: {},
	props: {},
	data() {
		return {
			isLoading: false,
			productId: '',
			productOptions: [],
			secretFromData: {},
			secretOptions: {
				emptyBtn: false,
				labelWidth: 120,
				column: [
					{
						label: '登录类型',
						prop: 'secretType',
						type: 'radio',
						span: 5,
						value: '1',
						dicData: [
							{
								label: '用户名',
								value: '1',
							},
							{
								label: '手机号',
								value: '2',
							},
						],
						rules: [
							{
								required: true,
								message: '请选择类型',
								trigger: 'blur',
							},
						],
						control: (value) => {
							return {
								secretContent: {
									label: value === '1' ? '用户名' : '手机号',
								},
							}
						},
					},
					{
						label: '是否跳转',
						prop: 'isAuto',
						type: 'radio',
						row: true,
						span: 5,
						value: '1',
						dicData: [
							{
								label: '是',
								value: '1',
							},
							{
								label: '否',
								value: '2',
							},
						],
						control: (value) => {
							let tempData = {
								page: {
									display: value === '1',
								},
							}
							if (value === '2') {
								tempData.port = {
									display: false,
								}
							}
							return tempData
						},
					},

					{
						label: '',
						prop: 'secretContent',
						span: 5,
						//类型为可选择，可搜索，可创建 18752004865 18362906622
						type: 'select',
						filterable: true,
						allowCreate: true,
						dicData: [
							{
								label: '18752004865',
								value: '18752004865',
							},
							{
								label: '18362906622',
								value: '18362906622',
							},
							{
								label: '18856065710-保',
								value: '18856065710',
							},
							{
								label: '13153840552',
								value: '13153840552',
							},
							{
								label: '18115168214',
								value: '18115168214',
							},
							{
								label: '美的光伏测试',
								value: '19862487987',
							},
							{
								label: '美的光伏正式',
								value: '18856065710',
							},
							{
								label: 'dingguoqing',
								value: 'dingguoqing',
							},
						],
						rules: [
							{
								required: true,
								message: '请输入',
								trigger: 'blur',
							},
						],
					},

					{
						label: '跳转页面',
						prop: 'page',
						type: 'select',
						display: true,
						span: 5,
						value: '',
						dicData: [],
						control: (value) => {
							return {
								port: {
									display: value.includes('localhost'),
								},
							}
						},
					},
					{
						label: '端口号',
						prop: 'port',
						display: false,
						value: '8080',
						span: 5,
					},
					{
						//有效期
						label: '有效期',
						prop: 'timeout',
						type: 'number',
						span: 5,
					},

					{
						label: '',
						prop: 'secretText',
						span: 3,
						disabled: true,
						formslot: true,
					},
				],
			},
			isSelecting: true,
			phoneNum: '',
			newCode: '',
		}
	},
	computed: {
		...mapGetters(['permissions']),
		getPermissions() {
			let {auth_login_pwd = false, auth_login_code = false} = this.permissions
			return {
				isShowSecret: auth_login_pwd && auth_login_code,
			}
		},
	},
	watch: {},
	methods: {
		onRefreshArea() {
			//刷新区域
			refreshArea().then((res) => {
				this.$message.success('省市区缓存更新成功！')
			})
		},
		onRefreshGong() {
			if (this.validatenull(this.productId)) {
				this.$message.error('请选择工种')
				return
			}
			refreshCategory(this.productId).then(() => {
				this.$message.success('工种更新成功！')
			})
		},
		onGetNewCode() {
			if (this.validatenull(this.phoneNum)) {
				this.$message.error('请输入手机号')
				return
			}
			this.isLoading = true
			this.newCode = ''
			//获取最新验证码
			getNewCode(this.phoneNum)
				.then((response) => {
					if (this.validatenull(response.data.data)) {
						this.$message.error('没有可用的验证码！')
						return
					}
					this.newCode = response.data.data || ''
				})
				.catch(() => {})
				.finally(() => {
					this.isLoading = false
				})
		},
		/**
		 * 管理后台增加功能用来获取临时密码和验证码，60 秒有效期，用过即失效：
		 * 1、输入用户名获取临时登录密码 GET /admin/auth/genSuperPassword?username= 权限标识：auth_login_pwd
		 * 2、输入手机号获取临时验证码 GET /admin/auth/genSuperCode?mobile= ，权限标识：auth_login_code，
		 * 现有超级验证码已废弃
		 */
		onGetNewSecret(form, done) {
			getNewSecret(this.secretFromData)
				.then((res) => {
					this.secretFromData.secretText = res.data.data
					//跳转页面
					let {secretType, isAuto = '1', page = '', port = '', secretContent, secretText} = this.secretFromData
					if (!page) {
						return
					}
					if (page.includes('localhost') && port !== '8080') {
						//本地的
						page = page.replace('8080', port)
					}
					page = `${page}/#/login`
					let toPage = `${page}?secretType123=${secretType}&name=${secretContent}&code=${secretText}`
					this.$Clipboard({text: toPage}).then(() => {
						this.$message.success('路径已复制成功！')
					})
					console.log('toPage-----', 'toPage')
					if (isAuto === '1') {
						//自动跳转
						window.open(toPage, '_blank')
					}
				})
				.finally(() => {
					done()
				})
		},
	},
	async created() {
		//请求产品数据
		let resList = (await fetchList({size: 999})) || {}
		let {code = -1, data: {records = []} = {}} = resList.data
		if (code === 0) {
			this.productOptions = records
		}
		this.isSelecting = false
	},
	mounted() {
		//处理跳转页面dic
		let tempPages = this.findObject(this.secretOptions.column, 'page')
		let {ieJtTest, ieJtPro, xsmTestMb, xsmProMb, isBxTest, meiGuangFuTest, meiGuangFuPro} = this.envConfig
		tempPages.value = isBxTest() ? ieJtTest : ieJtPro
		let tempTitle = isBxTest() ? '测试' : '正式'
		tempPages.dicData = [
			{
				label: `IE保-${tempTitle}`,
				value: isBxTest() ? ieJtTest : ieJtPro,
			},
			{
				label: `新市民-${tempTitle}`,
				value: isBxTest() ? xsmTestMb : xsmProMb,
			},
			{
				label: `美的光伏-${tempTitle}`,
				value: isBxTest() ? meiGuangFuTest : meiGuangFuPro,
			},
			{
				label: '开发环境',
				value: 'http://localhost:8080',
			},
		]
	},
	activated() {},
	updated() {},
	beforeDestroy() {},
	destroyed() {},
	beforeRouteEnter(to, from, next) {
		next()
	},
	beforeRouteUpdate(to, from, next) {
		next()
	},
	beforeRouteLeave(to, from, next) {
		next()
	},
}
</script>

<style lang="scss" scoped></style>
